import Actions from "common/Actions/Actions";
import { P } from "common/P/P";

import { routeConstants } from "navigation";

import { useNavigate } from "react-router-dom";

interface BetweenCompanyTableProps {
	orders: any;
	onRowClick?: (order: any) => void;
	type?: string | any;
	deletable?: boolean;
}

const BetweenCompanyTable: React.FC<BetweenCompanyTableProps> = ({
	orders,
	onRowClick,
	type,
}) => {
	console.log("sdasdasdsad", orders);
	const userString = localStorage.getItem("user");
	const user = userString ? JSON.parse(userString) : null;

	const userId = user ? user?.user._id : ""; // Replace with actual user ID
	const userTypeId = user ? user?.user.userTypeId?._id : null;
	const numericUserTypeId = parseInt(userTypeId);

	const navigate = useNavigate();

	const handleViewDocument = (order: any) => {
		navigate(
			`${routeConstants.seeDocument.route}?type=${type}&id=${order.letterInfo[0]._id}`
		);
	};

	return (
		<>
			<table className="w-full border rounded-lg border-strokeColor">
				<thead className="bg-white border border-strokeColor">
					<tr className="bg-bgColor">
						<th className="px-5 py-[18px] text-left border-b border-strokeColor">
							<P size="p3" type="regular" className="text-mainColor">
								Hatyň görnüşi
							</P>
						</th>
						<th className="px-5 py-[18px] text-left border-b border-strokeColor">
							<P size="p3" type="regular" className="text-mainColor">
								Senesi
							</P>
						</th>
						<th className="px-5 py-[18px] text-left border-b border-strokeColor">
							<P size="p3" type="regular" className="text-mainColor">
								Ugradylan ýeri
							</P>
						</th>
						<th className="w-16 px-5 py-[18px] text-left border-b border-strokeColor">
							<P size="p3" type="regular" className="text-mainColor">
								Amallar
							</P>
						</th>
					</tr>
				</thead>
				<tbody className="text-left">
					{orders.map((order: any, idx: any) => (
						<tr
							key={order._id + idx}
							className={`${
								idx === orders.length - 1
									? "border-0"
									: "border-b border-strokeColor"
							} ${
								order.expired
									? "bg-[#ffdfdf]"
									: idx % 2 === 0
									? "bg-white"
									: "bg-[#f9f9f9]"
							}`}
							onClick={() => onRowClick && onRowClick(order)}
						>
							<td
								className={`px-5 py-[18px] text-textColor font-medium ${
									idx === orders.length - 1 ? "" : ""
								}`}
							>
								<P size="p3" type="light">
									{order.letterInfo[0].letterType}
								</P>
							</td>
							<td className="px-5 py-[18px] font-medium text-textColor">
								<P size="p3" type="light">
									{new Date(order.createdAt)
										.toLocaleDateString("en-GB", {
											day: "2-digit",
											month: "2-digit",
											year: "numeric",
										})
										.replace(/\//g, ".")}
								</P>
							</td>

							<td
								className={`px-5 py-[18px] text-textColor font-regular ${
									idx === orders.length - 1 ? "" : ""
								}`}
							>
								<P size="p3" type="light">
									{order.fromCompany}
								</P>
							</td>

							<td className="px-5 py-[18px]">
								<Actions onView={() => handleViewDocument(order)} />
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</>
	);
};

export default BetweenCompanyTable;
